module.exports = __webpack_public_path__ + "img/8_sp.05168feb.gif";